import { useMutation } from "@tanstack/react-query";
import { Endpoints } from "@/constants";
import callAPI from "@/lib/callAPI";

const createContact = async (contactData) => {
  return callAPI({
    url: Endpoints.CREATE_CONTACT,
    method: "POST",
    data: contactData
  });
};

export const useCreateContact = () => {
  return useMutation({
    mutationFn: createContact,
    onSuccess: () => {
      console.log("Contact form submitted successfully");
    },
    onError: () => {
      console.log("error");
    }
  });
};
